<template>
  <parent>
    <user-form
      :id="id"
      editing
      @save="onSave"
    />
  </parent>
</template>
<script>
import UserForm from './Form.vue'

export default {
  components: { UserForm },
  data() {
    return {
      id: null,
    }
  },
  created() {
    this.id = this.$route.params.id
  },
  methods: {
    onSave(roleId) {
      const query = {
        userId: this.id,
        roleId,
      }
      this.$store.dispatch('projects/updateUser', query)
        .then(() => { this.$router.push({ name: 'project-settings', query: { tab: 1 } }) })
        .catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating user.') })
    },
  },
}
</script>
